// src/views/menage/BlocAApporter.jsx — « À APPORTER », d'après la maquette NEST
// v677 (`carteRun`, ligne 28091) : le manque signalé « pour la prochaine fois »
// par le ménage PRÉCÉDENT, montré à l'agent du ménage SUIVANT, en LECTURE.
//
//   · L'agent n'a aucun stock : il lit, l'orchestrateur prépare et dépose.
//   · Deux emplacements, MÊME bloc : la carte de sa journée ET la tête de
//     checklist — la donnée vient du guichet menage_log_info (a_apporter),
//     une seule source.
//   · FERMETURE : le dépôt du produit clôt le signalement (auto) — le bloc
//     disparaît seul ; sans dépôt, il RÉAPPARAÎT à chaque ménage suivant,
//     jamais d'expiration.

import { NEST, POLICE } from './palette-nest'

export default function BlocAApporter({ produits, testId }) {
  const liste = Array.isArray(produits) ? produits.filter(Boolean) : []
  if (!liste.length) return null
  return (
    <div data-testid={testId}
      style={{ background: NEST.aubPale, borderLeft: `3px solid ${NEST.aub}`, borderRadius: '0 10px 10px 0',
        padding: '8px 11px', fontSize: 13, lineHeight: 1.45, color: NEST.aubTexte, fontFamily: POLICE }}>
      <b>À apporter :</b> {liste.join(', ')} (signalé au dernier ménage)
    </div>
  )
}
